/** Shared payor key normalization for income stream matching in the admin SPA. */

export function normalizePayorKey(value: string | null | undefined): string {
  return String(value ?? '').trim().toLowerCase();
}

export function payorKeysMatch(a: string | null | undefined, b: string | null | undefined): boolean {
  const left = normalizePayorKey(a);
  const right = normalizePayorKey(b);
  if (!left || !right) return false;
  if (left === right) return true;
  if (left.length >= 4 && right.includes(left)) return true;
  if (right.length >= 4 && left.includes(right)) return true;
  return false;
}
